import { combineReducers } from '@reduxjs/toolkit';
import branding from './branding';
import callHistory from './callHistory';
import calls from './calls';
import client from './client';
import contacts from './contacts';
import extension from './extension';
import user from './user';
const appReducer = combineReducers({
    branding,
    callHistory,
    calls,
    client,
    contacts,
    extension,
    user,
});
export default appReducer;
